
(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcdms.vcFile.factory:FileHelper
   *
   * @description
   *
   */
  angular
    .module('vcreminder')
    .factory('LogReminderHelper', LogReminderHelper);


  LogReminderHelper.$inject = ['$uibModal', '$log', 'Rlog'];

  function LogReminderHelper($uibModal, $log, Rlog) {
    let HelperBase = {};

    HelperBase.addLog = addLog;
    HelperBase.addReminder = addReminder;


    function addLog(clientid, clientmode) {
      console.log('log modal add log: ', clientid, clientmode);
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><clientlog clientid="vm.clientid" mode="vm.clientmode"></clientlog></div>',
        controllerAs: 'vm',
        controller: ['clientid', 'clientmode', function (lclientid, lclientmode) {
          let vm = this;
          console.log('log modal ctrl: ', lclientid, lclientmode);
          vm.clientid = lclientid;
          vm.clientmode = lclientmode;
        }],
        resolve: {
          clientid: function () {
            return clientid;
          },
          clientmode: function () {
            return clientmode;
          }
        },
        size: 'lg'
      });
    }

    function addReminder(clientid, clientmode) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><clientreminder clientid="vm.clientid" mode="vm.clientmode"></clientreminder></div>',
        controllerAs: 'vm',
        controller: ['clientid', 'clientmode', function (lclientid, lclientmode) {
          let vm = this;
          vm.clientid = lclientid;
          vm.clientmode = lclientmode;
        }],
        resolve: {
          clientid: function () {
            return clientid;
          },
          clientmode: function () {
            return clientmode;
          }
        },
        size: 'lg'
      });
    }




    return HelperBase;
  }
}());
